import { CompanyComponent } from './company.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompanyService } from './company.service';

const routes: Routes = [
  {
    path: '',
    component: CompanyComponent,
    resolve: {
      company: CompanyService
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompanyRoutingModule { }
